/**
 * @generated SignedSource<<ed7e741cdc5eb9558f5402bdd5d67f34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type NoteHeader_note$data = {
  readonly event: {
    readonly guid: string;
    readonly " $fragmentSpreads": FragmentRefs<"JoinConferenceButton_event">;
  } | null;
  readonly hasMeetingRecordings: boolean;
  readonly id: string;
  readonly noteTitle: string;
  readonly noteType: NoteStreamType;
  readonly stream: {
    readonly displayName: string;
    readonly id: string;
  };
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"MoreActionsMenu_note" | "NoteHeaderTitleAndDate_note" | "RecordingControls_note">;
  readonly " $fragmentType": "NoteHeader_note";
};
export type NoteHeader_note$key = {
  readonly " $data"?: NoteHeader_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteHeader_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteHeader_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "noteTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteHeaderTitleAndDate_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecordingControls_note"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guid",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JoinConferenceButton_event"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MoreActionsMenu_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "da95720fa5bcb335832d7b6a53fb3646";

export default node;
